import { useMemo } from 'react';
import { RouteItemProps } from './types';
import { portalRoutes } from './portalRoutes';
import { loraWanRoutes } from './loraWanRoutes';

type RouteCategory =
  | 'assets'
  | 'alarms'
  | 'operational'
  | 'insights'
  | 'alerts'
  | 'financial'
  | 'sms'
  | 'access'
  | 'support'
  | 'administrative';

export type RouteDomain = Partial<Record<RouteCategory, RouteItemProps[]>>;

export const ROUTE_CATEGORY_ORDER: RouteCategory[] = [
  'assets',
  'alarms',
  'operational',
  'insights',
  'alerts',
  'financial',
  'sms',
  'access',
  'support',
  'administrative',
];

interface UseAppRoutes {
  allApplicationRoutes: RouteDomain;
}

export const useAppRoutes = (): UseAppRoutes => {
  function mergeRouteDomains(
    ...domains: RouteDomain[]
  ): Record<RouteCategory, RouteItemProps[]> {
    const result = {} as Record<RouteCategory, RouteItemProps[]>;

    ROUTE_CATEGORY_ORDER.forEach(category => {
      result[category] = domains.flatMap(domain => domain[category] ?? []);
    });

    return result;
  }

  const allApplicationRoutes = useMemo(
    () => mergeRouteDomains(portalRoutes, loraWanRoutes),
    [],
  );

  return {
    allApplicationRoutes,
  };
};
